import { textPropDefs } from './text.props';
const underline = ['auto', 'hover', 'always'];
const linkPropDefs = {
    size: textPropDefs.size,
    weight: textPropDefs.weight,
    trim: textPropDefs.trim,
    underline: { type: 'enum', values: underline, default: 'auto' },
    color: textPropDefs.color,
    highContrast: textPropDefs.highContrast,
};
export { linkPropDefs };
//# sourceMappingURL=link.props.js.map